import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Lib} from "../../../libs/Lib";
import {debounce} from "utils-decorators";

@Component({
    selector: 'app-image-loader',
    templateUrl: './image-loader.component.html',
    styleUrls: ['./image-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class ImageLoaderComponent implements OnInit {

    // tslint:disable-next-line
    @Input('style')
    _style: any = {};

    @Input()
    defaultImage = '';

    @Input()
    circle = false;

    @Input()
    images: Array<string> = [];

    public imageRetries = 0;
    public imageLoaded = false;
    randomString;

    constructor(public cdr: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.randomString = Lib.RandomString();
    }      

    public getImageUrl() {
        if (!this.images)
            return this.defaultImage;
        if (this.images.length === 0)
            return this.defaultImage;
        if (this.images[this.imageRetries] === undefined)
            return this.defaultImage;
        const url = this.images[this.imageRetries] + `?random=' ${this.randomString}`;
        return url;
    }

    public onImageLoaded() {
        this.imageLoaded = true;
        this.cdr.detach();
    }

    public onImageError() {
        this.imageRetries++;
    }

    public reloadImage() {
        this.randomString = Lib.RandomString();
        this.imageRetries = 0;
        this.cdr.reattach();
    }
}


